import React from "react";

const ArrowRight = ({canRedo, onClick}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      role="img" 
      aria-label="Press,To see next pair from history."
      onClick={onClick}
      className={canRedo ? 'is-active' : ''}>
      <path d="M3.74002 13.1C3.74003 13.5142 4.07581 13.85 4.49002 13.85H20.115L15.79 18.175C15.64 18.325 15.565 18.5 15.565 18.7C15.565 18.9 15.64 19.075 15.79 19.225C15.94 19.375 16.115 19.45 16.315 19.45C16.515 19.45 16.69 19.375 16.84 19.225L22.44 13.625C22.5234 13.5417 22.5817 13.4583 22.615 13.375C22.6484 13.2917 22.665 13.2 22.665 13.1C22.665 13 22.6484 12.9083 22.615 12.825C22.5817 12.7417 22.5234 12.6583 22.44 12.575L16.84 6.975C16.69 6.825 16.515 6.75 16.315 6.75C16.115 6.75 15.94 6.825 15.79 6.975C15.64 7.125 15.565 7.3 15.565 7.5C15.565 7.7 15.64 7.875 15.79 8.025L20.115 12.35H4.49002C4.07579 12.35 3.74 12.6858 3.74002 13.1Z"/>
      <title>Press,To see next pair from history.</title>
    </svg>
  );
};

export default ArrowRight;
